import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Spinner } from '../spinner/spinner.component';

import { selectCategoriesMap, selectIsCategoriesLoading } from '../../store/categories/category.selector';
import ProductCard from '../product-card/product-card.component';
import './category-prievie.style.scss'
import { Fragment } from 'react';

const CategoryPreview=({title,products})=>{

    const  categoriesMap=useSelector(selectCategoriesMap)
    const isLoading=useSelector(selectIsCategoriesLoading)
    return (
        <Fragment>
         {isLoading ? <Spinner /> : (
            <div className='category-preview-container'>
            <h2>
                <Link className='title' to={title}>{title.toUpperCase()}</Link>
            </h2>
            <div className='preview'>
                {
                    products.filter((_, idx)=> idx < 4).map((product)=><ProductCard key={product.id} product={product}/>)
                }

            </div>

        </div>
        )
            }
            </Fragment>)
       
    

}
 export default CategoryPreview;